export default {
  getHead: () => {
    return [{ name: "부서명" }, { name: "점검일" }, { name: "소속명" }, { name: "팀명" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 부서명
        case 1:
          return func.getContent(value).stdInfo.점검일; // 점검일
        case 2:
          return func.getContent(value).stdInfo.department; // 소속명
        case 3:
          return func.getContent(value).stdInfo.section; // 팀명
        case 4:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
    //[{name: '부서명'}, {name: '점검대상'}, {name: '점검일'}, {name: '점검장소'}, {name: '재해형태'}, {name: '소속명'}, {name: '팀명'}, {name: '작성자'}, {name: '작성일'}]
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    switch (nav.value.searchType) {
      case "부서명":
        returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
        break;
      case "점검일":
        returnData.push('content$body.stdInfo."점검일"*%[:default_skw]%');
        break;
      case "소속명":
        returnData.push("content$body.stdInfo.department*%[:default_skw]%");
        break;
      case "팀명":
        returnData.push("content$body.stdInfo.section*%[:default_skw]%");
        break;
    }

    return returnData;
  },
};
